import { useMutation, useQueryClient } from '@tanstack/react-query';
import PetProfile from '../../happypaws-shared/src/Pets/models/PetProfile';
import { api } from '../../services/api';

export const useUpdatePet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ petId, data }: { petId: string; data: Partial<PetProfile> }) => {
      const response = await api.patch(`/pets/${petId}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pets'] });
    },
  });
};
